import React from "react";

import { faArrowRotateLeft, faSoap, faWrench } from "@fortawesome/pro-regular-svg-icons";
import { SERVICE_TYPES } from "~/constants";
import { CHIP_COLOR_TYPES, ChipTooltip, CustomChip } from "../CustomChip.jsx";

const SERVICE_CENTRE_HANDLING = "It is shipped to the service centre instead of the returns warehouse, and is never refunded or quality checked.";

// Keyed by the backend ServiceType.
export const SERVICE_TYPE_MAP = {
    [SERVICE_TYPES.RETURN]: {
        label: "Standard return",
        icon: faArrowRotateLeft,
        colorType: CHIP_COLOR_TYPES.WHITE,
        selectable: true,
        content: "An ordinary return. The customer sends the items back to the returns warehouse to be quality checked and refunded.",
    },
    [SERVICE_TYPES.REPAIR]: {
        label: "Repair",
        icon: faWrench,
        colorType: CHIP_COLOR_TYPES.ACTION,
        selectable: true,
        content: `The customer registered this return for a repair. ${SERVICE_CENTRE_HANDLING}`,
    },
    [SERVICE_TYPES.WASH]: {
        label: "Wash",
        icon: faSoap,
        colorType: CHIP_COLOR_TYPES.ACTION,
        selectable: true,
        content: `The customer registered this return for a wash. ${SERVICE_CENTRE_HANDLING}`,
    },
};

export function isServiceType(serviceType) {
    return !!serviceType && serviceType !== SERVICE_TYPES.RETURN;
}

export function getServiceTypeConfig(serviceType) {
    // An unrecognised value still renders, labelled with the raw type, so a new backend
    // flow is visible rather than invisible.
    return (
        SERVICE_TYPE_MAP[serviceType] || {
            label: serviceType,
            icon: faWrench,
            colorType: CHIP_COLOR_TYPES.ACTION,
            content: `The customer registered this return for a service. ${SERVICE_CENTRE_HANDLING}`,
        }
    );
}

function ServiceTypeChipBase({ serviceType, ...chipProps }) {
    const config = getServiceTypeConfig(serviceType);
    return (
        <CustomChip
            {...chipProps}
            icon={config.icon}
            label={config.label}
            colorType={config.colorType}
            tooltipTitle={<ChipTooltip placement={chipProps.toolTipPlacement} title={`Return Type - ${config.label}`} content={config.content} />}
        />
    );
}

// Shown against a return. A standard return carries no service chip at all.
export function ServiceTypeChip({ serviceType, ...chipProps }) {
    if (!isServiceType(serviceType)) {
        return null;
    }
    return <ServiceTypeChipBase {...chipProps} serviceType={serviceType} />;
}

// Shown in the returns filter, where a standard return is a choice like any other and so
// has to render. Takes `status` because that is what TurnrDropdownSelectChip passes.
export function ServiceTypeFilterChip({ status, ...chipProps }) {
    return <ServiceTypeChipBase {...chipProps} serviceType={status} />;
}
